<template>
  <div class="pie-industry">
    <v-chart :options="pie" id="chartPie" auto-resize></v-chart>
    <div
      class="no-chart-data"
      style="color:#D3D3D3;font-size:20px;"
      v-show="isNodata"
    >Temporarily no data</div>
  </div>
</template>

<script>
let setOption = () => {
  // let barColor = [ "#FFAD5C", "#FF9F7F", "#FFDB5C", "#E7BCF3", "#E062AE", "#9084FF",
  //     "#12e78c", "#fe8104", "#8A2BE2", "#DC143C", "#fe3199", "#fef312", "#3f74fe", "#8A2BE2"];
  let barColor = [
    "#5C89FF",
    "#7C6AF2",
    "#C95FF2",
    "#FF6383",
    "#FF9F40",
    "#FFCB48",
    "#31DC72",
    "#26DAD0",
    "#5CB3FF",
    "#8290FF",
    "#EF6BBB",
    "#FF7979",
    "#EBE300",
    "#26E7C7",
    "#13BAED"
  ];

  let result = [];
  for (let i = 0; i < barColor.length; i++) {
    result.push({
      type: "bar",
      itemStyle: {
        normal: {
          color: barColor[i]
        }
      }
    });
  }
  return result;
};

let pieShow = [
  ["35%", "55%"],
  [0, 100]
];

export default {
  // props: ["echartsData", "pieName"],
  props: {
    echartsData: {},
    pieName: {},
    getSolid: {
      default: true
    },
    isNodata: {
      type: Boolean,
      default: false
    }
  },
  name: "pie",

  data() {
    return {
      pie: {},
      myChartPie: ""
    };
  },
  mounted() {
    this.setOptions();
    window.addEventListener("resize", () => {
      this.myChartPie.resize();
    });
  },
  methods: {
    setOptions() {
      let echarts = require("echarts");
      this.myChartPie = echarts.init(document.getElementById("chartPie"));

      let newResultData = this.$lodash.cloneDeep(this.echartsData);
      if (newResultData.length > 0) {
        newResultData.map((item, index) => {
          item = Object.assign(item, setOption()[index]);
        });
        this.pie = this.getOptions(newResultData, this.pieName, this.getSolid);
      } else {
        this.pie = this.getOptions(newResultData, this.pieName, this.getSolid);
      }
    },
    getOptions(resultpieData, pieName, isSolid) {
      return {
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
              title: "Save as picture"
            }
          },
          right: "1%"
        },
        grid: {
          left: "40%",
          right: "2%",
          bottom: "2%",
          top: "2%",
          containLabel: true
        },
        title: {
          text: "Industry Distribution",
          show: false
        },
        tooltip: {
          trigger: "item",
          confine:true,
          // position: ['5%', '30%'],
          formatter: function(parms) {
            var str =
              parms.marker +
              "" +
              parms.data.name +
              "</br>" +
              "Quantity: " +
              parms.data.value +
              "</br>" +
              "Proportion: " +
              parms.percent +
              "%";
            return str;
          },
          show: true
        },
        // legend: {
        //   //type: "scroll",
        //   type: "plain",
        //   icon: "circle", // circle  //roundRect
        //   // y: 'top',
        //   x: "left",
        //   orient: "vertical",
        //   // itemWidth && itemHeight 同时设置更改大小
        //   itemWidth: 9,
        //   itemHeight: 9,
        //   itemGap: 10,
        //   // left: "auto",
        //   // align: "left",
        //   // bottom: 0,
        //   formatter: function(name) {
        //     if (!name) return "";
        //     if (name.length > 5) {
        //       return name.slice(0, 30) + "...";
        //     }
        //   },
        //   textStyle: {
        //     color: "#8C8C8C",
        //     fontSize: 12
        //   },
        //   data: this.pieName
        // },

        series: [
          {
            name: "",
            type: "pie",
            center: ["50%", "50%"],
            // 饼图大小
            radius: ["40%", "60%"],
            // radius: isSolid == true ? pieShow[0] : pieShow[1],
            //饼图的扇区是否是顺时针排布
            clockwise: false,
            //视觉引导线 标签
            // label: {
            //   normal: {
            //     show: true,
            //     position: "outter",
            //     formatter: `${this.pieName}\n{hr|}\n{b} {d}% {c}`,
            //     rich: {
            //       hr: {
            //         // borderColor: "#12EABE",
            //         width: "100%",
            //         borderWidth: 1,
            //         height: 3
            //       }
            //     }
            //   }
            // },
            avoidLabelOverlap: true, //是否启用防止标签重叠策略

            data: resultpieData,
            // 视觉引导线
            label: {
              align: "left",
              normal: {
                fontFamily: "RCR",
                formatter(v) {
                  let text = v.name + " " + Math.round(v.percent) + "%";
                  // if (!text) return "";
                  // if (text.length > 5) {
                  //   return text.slice(0, 30) + "...";
                  // }
                  if (text.length <= 54) {
                    return text;
                  } else if (text.length > 54) {
                    return (text = `${text.slice(0, 54)}\n${text.slice(54,100)}\n${text.slice(100)}`);
                  }
                }
              }
            }
          }
        ]
      };
    }
  },
  watch: {
    getSolid(val) {},
    echartsData() {
      this.setOptions();
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 100%;
}
.pie-industry {
  position: relative;
}
.pie-industry .no-chart-data {
  width: 300px;
  font-size: 25;
  font-weight: 600;
  position: absolute;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -588%);
}
/* .pie-industry {
  width: 700px;
} */
</style>
